__turbopack_context__.v({
  "description": "xqXPsq_description",
  "descriptionSpaced": "xqXPsq_descriptionSpaced",
  "header": "xqXPsq_header",
  "headerRow": "xqXPsq_headerRow",
  "headerText": "xqXPsq_headerText",
  "headingFlush": "xqXPsq_headingFlush",
  "section": "xqXPsq_section",
  "subTitle": "xqXPsq_subTitle",
  "title": "xqXPsq_title",
});
